import $ from 'jquery';
window.$ = window.jQuery = $;

import * as bootstrap from 'bootstrap-italia';
window.bootstrap = bootstrap;

/*
    At some point of history, in BootstrapItalia have been removed functions to
    integrate Bootstrap JS widgets with jQuery.
    Here I provide back the same functions, took from vanilla Bootstrap
*/

window.bootstrap['Modal'].jQueryInterface = function(config, relatedTarget) {
    return this.each(function () {
        const data = window.bootstrap['Modal'].getOrCreateInstance(this, config);

        if (typeof config !== 'string') {
            return;
        }

        if (typeof data[config] === 'undefined') {
            throw new TypeError(`No method named "${config}"`);
        }

        data[config](relatedTarget);
    });
};

window.bootstrap['Popover'].jQueryInterface = function(config) {
    return this.each(function () {
        const data = window.bootstrap['Popover'].getOrCreateInstance(this, config);

        if (typeof config !== 'string') {
            return;
        }

        if (typeof data[config] === 'undefined') {
            throw new TypeError(`No method named "${config}"`);
        }

        data[config]();
    });
};

window.bootstrap['Tooltip'].jQueryInterface = function(config) {
    return this.each(function () {
        const data = window.bootstrap['Tooltip'].getOrCreateInstance(this, config);

        if (typeof config !== 'string') {
            return;
        }

        if (typeof data[config] === 'undefined') {
            throw new TypeError(`No method named "${config}"`);
        }

        data[config]();
    })
};
